'use client';

import { createContext, useContext, ReactNode } from 'react';
import { IPhrases } from '@/types/types/page/pages';

const DefaultPhrasesContext = createContext<IPhrases | undefined | null>(undefined);

interface DefaultPhrasesProviderProps {
    phrases?: IPhrases | null;
    children: ReactNode;
}

export function DefaultPhrasesProvider({ phrases, children }: DefaultPhrasesProviderProps) {
    return (
        <DefaultPhrasesContext.Provider value={phrases}>{children}</DefaultPhrasesContext.Provider>
    );
}

export const useDefaultPhrasesContext = () => {
    return useContext(DefaultPhrasesContext);
};
